import { User } from '../_classes/list/user';

export let Users: User[] = [
  {
    id: 1,
    username: 'opo_usr@mail.ru',
    password: null,
    confirmPassword: null,
    first_name: 'А.А.',
    last_name: 'Иванов',
    firm_id: 1,
    firm: 'КСП города Челябинска',
    phone: '8 908 888 78 74',
    role0: true,
    role1: true,
    role2: true,
    role3: true,
    role4: true,
    checked: true,
    dt: null,
    dtm: null
  },
  {
    id: 2,
    username: 'usz@cheladmin.ru',
    password: null,
    confirmPassword: null,
    first_name: 'А.Е.',
    last_name: 'Иванова',
    firm_id: 1,
    firm: 'КСП города Челябинска',
    phone: '8 908 888 78 74',
    role0: true,
    role1: false,
    role2: true,
    role3: false,
    role4: true,
    checked: true,
    dt: null,
    dtm: null
  },
  {
    id: 3,
    username: 'rob_t@mail.ru',
    password: null,
    confirmPassword: null,
    first_name: 'Р.А.',
    last_name: 'Сидоренко',
    firm_id: 2,
    firm: 'МКУ «Социальный дом ветеранов»',
    phone: '8 908 888 78 74',
    role0: true,
    role1: false,
    role2: false,
    role3: false,
    role4: false,
    checked: true,
    dt: null,
    dtm: null
  },
  {
    id: 4,
    username: 'rob_t1@mail.ru',
    password: null,
    confirmPassword: null,
    first_name: 'Л.Ф.',
    last_name: 'Пупик',
    firm_id: 2,
    firm: 'МКУ «Социальный дом ветеранов»',
    phone: '8 908 888 78 74',
    role0: true,
    role1: false,
    role2: false,
    role3: false,
    role4: false,
    checked: false,
    dt: null,
    dtm: null
  }
]



// WEBPACK FOOTER //
// /usr/home/rob/Staxi/client/src/app/_mock/users.ts